"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterToRecordValueConversionError = exports.isClipboardRangeJSONValue = exports.isClipboardJSONValue = void 0;
const isClipboardJSONValue = (value) => {
    return (typeof value === "object" &&
        value !== null &&
        "field" in value &&
        "value" in value);
};
exports.isClipboardJSONValue = isClipboardJSONValue;
const isClipboardRangeJSONValue = (value) => {
    return (typeof value === "object" &&
        value !== null &&
        "fields" in value &&
        "values" in value);
};
exports.isClipboardRangeJSONValue = isClipboardRangeJSONValue;
class FilterToRecordValueConversionError extends Error {
    constructor(field, filterValue, comparison) {
        const message = `Could not convert filter value ${JSON.stringify(filterValue)} to record value for field ${field.slug} with comparison ${comparison}`;
        super(message);
        this.name = "FilterToRecordValueError";
        this.field = field;
        this.filterValue = filterValue;
        this.comparison = comparison;
    }
}
exports.FilterToRecordValueConversionError = FilterToRecordValueConversionError;
